import { render, staticRenderFns } from "./ProductEssentialControls.vue?vue&type=template&id=20c6bb67&"
import script from "./ProductEssentialControls.vue?vue&type=script&lang=js&"
export * from "./ProductEssentialControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports